import React from "react";
import styled from "styled-components";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// Chart.js 구성 요소 등록
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const PointComparisonContainer = styled.div`
  width: 500px;
  height: 300px;
  @media (max-width: 600px) {
    width: 100%;
    height: 200px;
  }
`;
export default function PointComparison({ beforeStats, afterStats }) {
  const before = beforeStats.count;
  const after = afterStats.count;

  const data = {
    labels: ["보정 전", "보정 후"],
    datasets: [
      {
        label: "포인트 개수",
        backgroundColor: ["rgba(255, 99, 132, 0.7)", "rgba(54, 162, 235, 0.7)"],
        borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
        borderWidth: 1,
        data: [before, after],
        // 막대 너비 조절
        barThickness: 60, // 픽셀 단위로 막대 너비 지정
      },
    ],
  };

  // Y축 범위 동적 계산 함수
  const calculateYAxisRange = (dataValues) => {
    const maxValue = Math.max(...dataValues);
    const minValue = Math.min(...dataValues);

    // 최대값과 최소값의 차이를 계산
    const range = maxValue - minValue;

    // 여백을 추가 (10% 정도)
    const padding = range * 0.1;

    return {
      min: Math.max(0, minValue - padding), // 음수가 되지 않도록
      max: maxValue + padding,
    };
  };
  const yAxisRange = calculateYAxisRange(data.datasets[0].data);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: "포인트 개수 비교 (보정 전후)",
        font: {
          size: 15,
          weight: "500",
        },
        color: "white", // 제목 색상
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.parsed.y.toLocaleString();

            // 데이터셋의 첫 번째 값과 현재 값 비교
            const firstValue = context.dataset.data[0];
            const currentValue = context.parsed.y;

            let change = "";
            if (context.dataIndex > 0) {
              // 첫 번째가 아닌 경우에만
              const decreasePercent = (
                ((firstValue - currentValue) / firstValue) *
                100
              ).toFixed(2);
              change = `(${decreasePercent}% 감소)`;
            }

            return `포인트 개수: ${value} ${change}`;
          },
        },
      },
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: false,
        ticks: {
          callback: function (value) {
            return (value / 1000000).toFixed(1) + "M";
          },
          color: "white", // Y축 눈금 색상
        },
        // 동적으로 계산된 Y축 범위 적용
        min: yAxisRange.min,
        max: yAxisRange.max,
        grid: {
          color: "rgba(255, 255, 255, 0.1)", // 그리드 색상 (반투명 흰색)
        },
      },
      x: {
        ticks: {
          color: "white", // X축 눈금 색상
        },
        grid: {
          color: "rgba(255, 255, 255, 0.1)", // 그리드 색상 (반투명 흰색)
        },
      },
    },
  };

  return (
    <PointComparisonContainer>
      <Chart type="bar" data={data} options={options} />
    </PointComparisonContainer>
  );
}
